module.exports = __webpack_public_path__ + "img/dxtop.af884f09.png";